import { ElementRef } from '@angular/core';

export function loadExternalScript(htmlElement: ElementRef, scriptUrl: string) {
  const element = htmlElement.nativeElement;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = scriptUrl;
  element.appendChild(script);
}
